import React, {useRef, useState} from 'react';
import {FaTimes} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import ModalImage from "../../../../../components/modal/modal-image.jsx";

const MonitoringFaceImage = ({preview, image, hasImage, disabled, onFileSelected, onRemove}) => {
    const fileRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [expandSrc, setExpandSrc] = useState(preview);

    const openPicker = () => fileRef.current?.click();

    const onClickArea = () => {
        if (hasImage) {
            setExpandSrc(image ? URL.createObjectURL(image) : preview);
            setExpanded(true);
            return;
        }
        openPicker();
    };

    const closeExpand = (open) => {
        setExpanded(open);
        if (!open && expandSrc?.startsWith("blob:")) URL.revokeObjectURL(expandSrc);
    };

    return (
        <div className={"flex flex-col h-full"} style={disabled ? {pointerEvents: "none", opacity: 0.45} : undefined}>
            <div
                className={"relative flex-1 min-h-[180px] bg-white border border-[#e0e0e0] rounded p-1 cursor-pointer overflow-hidden"}
                style={{
                    backgroundImage: `url(${preview})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                }}
                onClick={onClickArea}
            >
                {
                    hasImage &&
                    <Button
                        target={"danger"}
                        className={"absolute top-1 right-1"}
                        title={"Remover imagem"}

                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove();
                        }}
                    >
                        <FaTimes/>
                    </Button>
                }
                {
                    !hasImage &&
                    <p className={"opacity-45 h-full content-center text-center uppercase m-0"}>Foto da face</p>
                }
            </div>

            <input
                ref={fileRef}
                type="file"
                className={"hidden"}
                accept="image/jpeg"
                onChange={(e) => {
                    const file = e.target.files[0];
                    e.target.value = null;
                    onFileSelected(file);
                }}
            />

            <Button target={"primary"} className={"w-full mt-2"} onClick={openPicker} disabled={disabled}>
                Selecionar foto
            </Button>

            <ModalImage open={expanded} setOpen={closeExpand} imgUrl={expandSrc}/>
        </div>
    );
};

export default MonitoringFaceImage;